import * as React from "react";

import { Dispatch } from "redux";
import { connect } from "react-redux";
import { ReduxActions, ReduxState } from "../../store";

import strings from "../../localization/strings";

import { initGA } from "../../utils/ga-utils";
import styles from "../../styles/generic/cookie-consent";
import { setLocale } from "../../actions/locale";
import { CustomStyles } from "../../types";
import { withCustomStyles } from "../hocs/with-custom-styles";
import ReactCookieConsent from "react-cookie-consent";
import { withStyles, WithStyles } from "@material-ui/core";

/**
 * Interface describing component props
 */
interface Props extends WithStyles<typeof styles> {
  locale: string;
  customStyles?: CustomStyles;
}

/**
 * Cookie consent component
 *
 * @param props component props
 */
const CookieConsent: React.FC<Props> = ({
  classes
}) => {

  /**
   * Activate google analytics if consent is accepted
   */
  const handleAcceptCookie = () => {
    if (process.env.REACT_APP_GOOGLE_ANALYTICS_ID) {
      initGA(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
    }
  };

  return (
    <ReactCookieConsent
      enableDeclineButton
      onAccept={ handleAcceptCookie }
      disableButtonStyles={ true }
      buttonText={ strings.cookieConsent.approve }
      declineButtonText={ strings.cookieConsent.decline }
      buttonClasses={ classes.button }
      declineButtonClasses={ classes.button }
      >
      { strings.cookieConsent.mainText }
    </ReactCookieConsent>
  );
}

/**
 * Redux mapper for mapping store state to component props
 *
 * @param state store state
 */
function mapStateToProps(state: ReduxState) {
  return {
    keycloak: state.auth.keycloak,
    locale: state.locale.locale,
    accessToken: state.auth.accessToken
  };
}

/**
 * Redux mapper for mapping component dispatches
 *
 * @param dispatch dispatch method
 */
function mapDispatchToProps(dispatch: Dispatch<ReduxActions>) {
  return {
    setLocale: (locale: string) => dispatch(setLocale(locale))
  };
}

const Styled = withStyles(styles)(CookieConsent);
const CustomStyled = withCustomStyles("generic/cookie-consent")(Styled);
const Connected = connect(mapStateToProps, mapDispatchToProps)(CustomStyled);

export default Connected;
